function parseExamUrlParams() {
  const params = new URLSearchParams(window.location.search);

  const isDemoExamRaw = params.get("isDemoExam");
  const productType = params.get("productType");
  const productId = params.get("productId");
  const uprId = params.get("userProductRegistrationId");
  const token = params.get("token");
  const sessionId = params.get("sessionId");
  const scratch = params.get("scratch");

  return {
    isDemoExam: isDemoExamRaw === "true" || isDemoExamRaw === null,
    isInstantExam: productType === "ielts-instant-exam",
    productType,
    productId,
    uprId,
    token,
    sessionId,
    scratch,
  };
}

export const examUrlParams = parseExamUrlParams();
